import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import ColumnPlot from "./ColumnPlot";
import { FlexColumn, Text } from "../../styles/Global";
import { usePlayerPPRScoreMutation } from "../../services/playerApi";
import SkeletonLoader from "../../components/SkeletonLoader";
import { setChartData } from "../../features/player/chartDataSlice";

const mapDispatch = { setChartData };

const PPRColumnChart = ({
  userID,
  requestBody,
  sport,
  FormatTimestamps,
  setChartData,
  hideTitle,
}) => {
  const savedChartData = useSelector((state) => state.chartData.playerPPR);
  const [data, setData] = useState(savedChartData);
  const [
    getPlayerPPRScore,
    { data: playerPPRData, error: playerPPRError, isLoading: playerPPRLoading },
  ] = usePlayerPPRScoreMutation();
  console.log("Player PPR Score: ", playerPPRData);
  console.log("Player PPR Score Data: ", data);
  useEffect(() => {
    console.log("getting Player PPR Score");
    getPlayerPPRScore(requestBody);
  }, []);
  useEffect(() => {
    if (playerPPRData) {
      setChartData({ playerPPR: playerPPRData });
      setData(playerPPRData);
    }
  }, [playerPPRData]);
  return data ? (
    <div>
      {data &&
      data.statusCode === 0 &&
      data.chart.length &&
      data.chart[0].roundcount > 0 ? (
        <>
          <FlexColumn style={{ flex: 1, marginTop: 10, width: "100%" }}>
            {!hideTitle && (
              <Text
                size=".8em"
                style={{
                  fontStyle: "italic",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                Based off of {data.chart[0].roundcount} rounds in the last 120
                days.{" "}
              </Text>
            )}
          </FlexColumn>
          <ColumnPlot type="num" x="num" y="total" data={data.chart} />
        </>
      ) : (
        <FlexColumn
          style={{
            width: "100%",
            textAlign: "center",
            alignSelf: "center",
            marginTop: 20,
          }}
          align="center"
          justify="center"
        >
          <Text>No PPR Data available yet</Text>
          <Text style={{ marginTop: 5 }} size=".8em">
            Ask your organizer to use ScoreMagic!
          </Text>
        </FlexColumn>
      )}
    </div>
  ) : (
    <SkeletonLoader h1={200} />
  );
};

export default connect(null, mapDispatch)(PPRColumnChart);
